import service from "@/plugins/request";

/**
 * 发布
 * @param {*} params
 * @returns
 */
export function apiEntryTemplateAdd(params) {
  return service({
    url: "/v1/protected/entryTemplate/add",
    method: "post",
    data: params,
    successToast: true
  });
}

/**
 * 详情
 * @param {*} params
 * @returns
 */
export function apiEntryTemplateDetail(params) {
  return service({
    url: "/v1/protected/entryTemplate/detail",
    method: "get",
    params
  });
}

/**
 * 草稿
 * @param {*} params
 * @returns
 */
export function apiDraftAdd(params) {
  return service({
    url: "/v1/protected/draft/add",
    method: "post",
    data: params,
    successToast: true
  });
}

/**
 * 草稿
 * @param {*} params
 * @returns
 */
export function apiDraftDetail(params) {
  return service({
    url: "/v1/protected/draft/detail",
    method: "get",
    params
  });
}

/**
 * 绑定数据源
 * @returns
 */
export function apiEntryBind(params) {
  return service({
    url: "/v1/protected/entryBind/bind",
    method: "post",
    data: params
  });
}

/**
 * 获取数据源列表
 * @returns
 */
export function apiGetEntryBindList(params) {
  return service({
    url: "/v1/entryBind/list",
    method: "get",
    params
  });
}
